import uploadingStatuses from 'shared/constants/uploading-statuses';
import { getVideosGroupedByIds } from 'shared/selectors/videos';


export function toFakeVideoData(file) {
  const now = new Date();

  let fakeVideoData = {
    id: _.uniqueId('FAKE-'),
    uploadingStatus: uploadingStatuses.WAITING,
    createdTs: now,
    updatedTs: now,
  };

  if (file) {
    const { name, size } = file;
    fakeVideoData = {
      ...fakeVideoData,
      title: name.replace(/(.+)\.[a-z0-9]+$/i, '$1'),
      uploadedSize: 0,
      fileSize: size,
    };
  }

  return fakeVideoData;
}

export function addDataToSameChannelVideos(normalizedData, state) {
  const currentVideoId = normalizedData.result;

  const videoByIds = getVideosGroupedByIds(state);
  const channelVideoIds = _(videoByIds)
    .filter(({ baseItemId }) => baseItemId === currentVideoId)
    .map('id')
    .value();

  const currentVideoData = _.pick(normalizedData.entities.videos[currentVideoId], [
    'coverUrl', 'durationSec', 'durationStr', 'getVideoUrls', 'getVideoUrlsByFileName', 'error',
    'mediaFileName', 'mediaInfo', 'mediaType', 'title', 'transcodingStatus', 'uploadingStatus', 'updatedTs',
  ]);

  _.forEach(channelVideoIds, function (videoId) {
    normalizedData.entities.videos[videoId] = currentVideoData;
  });
}



// WEBPACK FOOTER //
// ./src/dashboard/redux/helpers/upload.js